import { useCurrentShopSuspense } from "@/api/shops/use-current-shop-suspense";
import { ShopViewDto } from "@babackapp/private-api-client/types";
import { useMemo } from "react";

/**
 * As we have groupped some columns together,
 * we need to map the new keys to the old keys
 */
export const viewsNewKeysMapper = {
  orderName: "order",
  orderId: "order",
  "shipping_info.tracking_code": "tracking_code",
  "customer.email": "customer",
  "customer.name": "customer",
};

export function mapShopViewToTableColumns(view: ShopViewDto): ShopViewDto {
  return {
    id: view.id,
    name: view.name,
    fields: view.fields.map((field) => {
      return {
        name:
          field.name in viewsNewKeysMapper
            ? viewsNewKeysMapper[field.name as keyof typeof viewsNewKeysMapper]
            : field.name,
        active: field.active,
      };
    }),
  };
}

export function useShopViews() {
  const { data: shop } = useCurrentShopSuspense();
  const views = useMemo(
    () => shop.views.map(mapShopViewToTableColumns),
    [shop.views],
  );

  return views;
}
